export default "__VITE_ASSET__dXbR9w2X__"